import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

class ScrollClass {
    constructor() {
        this.init();
    }

    init() {
        this.dom();

        if (this.$elements.length > 0) {
            this.setup();
        }
    }

    dom() {
        this.$window = $(window);
        this.$document = $(document);
        this.$elements = $('*[data-scroll-class]');
    }

    setup() {
        // setup scrolltrigger
        gsap.registerPlugin(ScrollTrigger);

        this.$elements.each((i) => {
            const $element = this.$elements.eq(i);
            const toggleClass = $element.data('scroll-class');

            const options = {
                trigger: $element.get(0),
                // start: $element.data('scroll-start') || 'top bottom',
                // start: "top+=100px bottom-=250px",
                start: () => {
                    const $scrollStart = $element.data('scroll-start');
                    
                    if ($scrollStart) return $scrollStart;

                    // calculate bottom element space
                    const windowHeight = this.$window.height();
                    const documentHeight = this.$document.height();
                    const elementTop = $element.offset().top;                    
                    const elementHeight = $element.outerHeight();
                    let trigger = windowHeight / 2;

                    let bottomSpace = $element.data('scroll-bottom-space');
                    if (!bottomSpace) {
                        bottomSpace = documentHeight - (elementTop + elementHeight);
                        $element.attr('data-scroll-bottom-space' , bottomSpace);
                    }

                    if (trigger > bottomSpace) {
                        trigger = bottomSpace;
                    }

                    return 'top bottom-=' + trigger + 'px';
                },
                // end: 'bottom',
                toggleClass: {targets: $element.get(0), className: toggleClass},
                once: Boolean($element.data('scroll-once')) || false,
                onToggle: () => {
                    ScrollTrigger.refresh();
                },
                // markers: Boolean($element.hasClass('service')) || false,
            };

            // Refresh after height transition
            $element.on('transitionend', function(event) {
                if (
                    event.originalEvent.propertyName === 'height' ||
                    event.originalEvent.propertyName === 'max-height'
                ) {
                    ScrollTrigger.refresh();
                }
            });
              
            ScrollTrigger.create(options);
        });
    }
}

export default ScrollClass;
